import apiClient from '../config/api';

const excelImportService = {
  // Get supported master data types
  getSupportedTypes: async () => {
    const response = await apiClient.get('/excelimport/supported-types');
    return response.data;
  },

  // Download template for a master data type
  downloadTemplate: async (masterDataType) => {
    const response = await apiClient.get(`/excelimport/template/${masterDataType}`, {
      responseType: 'blob',
    });
    
    // Create blob URL and trigger download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${masterDataType}_Template.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  // Import data from Excel file
  importFromExcel: async (masterDataType, file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post(
      `/excelimport/import/${masterDataType}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },
};

export default excelImportService;

